import React, { useEffect, useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import PartnerPersonalData from "../../../Components/PartnerAdminDashboardComp/PartnerDetails/PartnerPersonalData";
import PartnerBankData from "../../../Components/PartnerAdminDashboardComp/PartnerDetails/PartnerBankData";
import PartnerDetailComponent from "../../../Components/PartnerAdminDashboardComp/PartnerDetails/PartnerDetailComponent";
import PartnerMapClient from "../../../Components/PartnerAdminDashboardComp/PartnerDetails/PartnerMapClient"
import { partner_Admin } from "../../../Configuration/Partner_URL";
import { toast } from "react-toastify";
import { decryptData } from "../../../CommonMethhods/CommonMethods";
import { axiosSsoText } from "../../../CommonMethhods/axiosPartnerInterceptor";


function PartnerDetailsDashboard() {
  const storeToken = localStorage.getItem("ssoToken");
  const id = localStorage.getItem("storePartnerId");
  const [partnerDetails, setPartnerDetails] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [active, setIsActive] = useState("");

  if(storeToken == null){
    window.location.replace("/")
  }

  const getPartnerId = async () => {
    try {
      const getDetail = await axiosSsoText.get(
        `${partner_Admin.GetPartnerById}?pid=${id}`,
      );
      const res = decryptData(getDetail?.data);
      let decryptedRes = JSON.parse(res);
      if(decryptedRes?.status === 0){
      setPartnerDetails(decryptedRes?.data?.info)
      setIsActive(decryptedRes?.data?.info?.isActive);
      setErrorMsg("");
      localStorage.setItem("getPartnerCode", decryptedRes?.data?.info?.partnerCode);
      }
      else{
        // toast.error(decryptedRes?.message);
        setErrorMsg(decryptedRes?.message);
      }
      
    } catch (error) {
      console.log(error);
    }
    
  };

  useEffect(() => {
    getPartnerId();
    
  }, []);

console.log(active, "isActive");
  return (
    <>
      <Header  portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div>
          <PartnerDetailComponent partnerDetails={partnerDetails}
          id={id}
          getPartnerId={getPartnerId}
          active={active}
          errorMsg={errorMsg}
          />
          <PartnerPersonalData partnerDetails={partnerDetails} 
          id={id}
          getPartnerId={()=>getPartnerId()}
          active={active}
          errorMsg={errorMsg}
          />
          <PartnerBankData partnerDetails={partnerDetails} 
          id={id}
          getPartnerId={()=>getPartnerId()}
          active={active}
          errorMsg={errorMsg}

          />
          <PartnerMapClient partnerDetails={partnerDetails}
          active={active}
           />
        </div>
      </main>
    </>
  );
}

export default PartnerDetailsDashboard;
